import { FetchAPI } from 'utils/fetch/fetch-api';
import { BankAccountDTO } from 'utils/types/bank-accounts';
import { RequestQuery } from 'utils/types/request-types';

class BankAccountService extends FetchAPI {
	getBankAccount = (query: RequestQuery): Promise<BankAccountDTO> => this.get<BankAccountDTO>(query);
}

export { BankAccountService };
